import { useCallback } from "react";
import { getClientDomain, getToken } from "../utils/Common";


export const useOffice = () => {

    const getPostOfficeStatus = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/postOffice/status`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const getPostOfficeMovements = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/postOffice/movements`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const getAllPostOfficesMovements = useCallback(async (signal,data) => {
        const response = await fetch(`${getClientDomain()}/postOffice/allMovements`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },

            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        }
        else {
            return { ...result, payload: [] };
        }
    }
    , []);
                 

    const addRemovePostOffice = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/postOffice/addRemove`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
        else return {...result};
    }, []);

    const getPostOfficeBalances = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/postOffice/balances`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`,
            },
            signal: signal
        });

        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const getAllPostOffices = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/postOffice/all`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
   
        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result?.payload;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const createOffice = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/postOffice/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
        else return {...result};
    }, []);

    const  updatePostOffice = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/postOffice/update`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
        else return {...result};
    }
    , []);

    const getPostOfficesList = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/postOffice/list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();
   
        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result?.payload;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }, []);

    const managePostOffice = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/postOffice/manage`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
        else return {...result};
    }, []);

    const getListProvinces = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain()}/postOffice/listProvinces`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
   
        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result?.payload;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        } else {
            return { ...result, payload: [] };
        }
    }
    , []);

    const searchReportCT = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain()}/postOffice/searchRCT`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data),
            signal: signal
        });
        const result = await response.json();

        if (Array.isArray(result?.payload) && result.payload.length > 0) {
            return result;
        } else if (result?.payload) {
            return { ...result, payload: [result.payload] };
        }
        else {
            return { ...result, payload: [] };
        }
    }, []);

    return { getPostOfficeStatus, getPostOfficeMovements, addRemovePostOffice, 
        getPostOfficeBalances, getAllPostOffices, getAllPostOfficesMovements, 
        createOffice,  updatePostOffice, getPostOfficesList, managePostOffice, getListProvinces, searchReportCT};
}